export default __webpack_public_path__ + "static/media/calais.b0026466.jpg";